import React, { useState } from 'react';
import { Layout, Menu, Spin, Row, Col, Space, Avatar, Typography, Dropdown, Modal, Button, Form, Input, message } from "antd";
import { UserOutlined, LogoutOutlined, LockOutlined, FilePdfOutlined } from "@ant-design/icons";
import FileSaver from "file-saver";
import useAuth from "utils/auth/hooks";
import ChangePasswordForm from './ChangePasswordForm';
import constant from 'constants/constant';

const { Text } = Typography;

export default function Header() {
  const { methods, data } = useAuth();

  const [userModalVisible, setUserModalVisible] = useState(false);

  function handleMenuClick(e){
    if(e.key === 'userGuidance'){
      const isVendor = data?.userData?.userInfo?.purchaseType === constant.purchaseType.cv.value 
        && (data?.userData?.userInfo?.vendorId != null && data?.userData?.userInfo?.vendorId != 0);

      const filePath = isVendor 
        ? "/assets/userguide/Ext_UserGuideMCPApplication.pdf"
        : "/assets/userguide/Int_UserGuideMCPApplication.pdf";

      FileSaver.saveAs(
        process.env.PUBLIC_URL + filePath,
        "User Guide MCP Application.pdf"
      );
    }
    else if(e.key === "changePassword"){
      setUserModalVisible(true);
    }
    else if(e.key === "logout"){
      methods.handleLogout();
    }
  }

  function close() {
    //form.resetFields();
    setUserModalVisible(false);
  }

  const userMenu = (
    <Menu>
      <Menu.Item 
        key="userGuidance" onClick={handleMenuClick}
        icon={<FilePdfOutlined />}>
          User Guidance
      </Menu.Item>
      <Menu.Item 
        key="changePassword" onClick={handleMenuClick}
        icon={<UserOutlined />}>
          Change Password
      </Menu.Item>
      <Menu.Item 
        key="logout" onClick={handleMenuClick}
        icon={<LogoutOutlined />}>
          Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Layout.Header
        className="site-layout-background"
        style={{
          position: "fixed",
          zIndex: 1,
          width: "100%",
          backgroundColor: "#47CFD4",
        }}
      >
        <Row style={{width:"90%"}}>
          <Col span={19}></Col>
          <Col span={4} style={{textAlign:"right"}}>
            <Dropdown onClick={() => {}} overlay={userMenu}>
              <div>
              <Avatar
                style={{ backgroundColor: "#87d068", marginRight:"8px" }}
                icon={<UserOutlined />}
                shape="square"
                size="small"
              />
              <Text style={{ color: "#FFFF" }}>
                {data?.userData?.userInfo?.firstName}
              </Text>
              </div>
            </Dropdown>
          </Col>
        </Row>
      </Layout.Header>
      <Modal
        visible={userModalVisible}
        title="Change Password"
        onCancel={close}
        footer={null}
      >
        <ChangePasswordForm onFinish={close} />
      </Modal>
    </>
  )
}
